import { Link } from "react-router-dom";
import styled from "styled-components";
import Button from "../../common/Button";
import Container from "../../common/Container";
import appConfig from "../../config/appConfig";

/**
 * Drop your photo into public/images/hero.webp (or .jpg/.png).
 * The dark overlay is applied via the linear-gradient so text stays readable
 * regardless of the image brightness. Compression tips: see scripts/compress-hero.sh
 */
const Hero = styled.section`
  background:
    linear-gradient(rgba(3, 105, 161, 0.65), rgba(3, 105, 161, 0.65)),
    url("/images/hero.webp") center 40% / cover no-repeat,
    #0369a1; /* fallback colour if the image hasn't loaded yet */
  color: #fff;
  padding: 6.5rem 1.25rem;
  min-height: 500px;
  text-align: center;
`;

const Title = styled.h1`
  color: #fff;
  font-size: clamp(2rem, 5vw, 3.5rem);
  margin: 0 0 1rem;
`;

const Lead = styled.p`
  font-size: 1.15rem;
  max-width: 640px;
  margin: 0 auto 2rem;
`;

const Cards = styled.div`
  display: grid;
  gap: 1.25rem;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  margin-top: 1rem;
`;

const Card = styled(Link)`
  display: block;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 1.25rem;
  text-decoration: none;
  color: inherit;
  &:hover {
    border-color: var(--color-primary);
  }
  h3 {
    margin-top: 0;
  }
`;

function Welcome() {
  return (
    <>
      <Hero>
        <Title>{appConfig.clubName}</Title>
        <Lead>
          A community of paramotor pilots in western Pennsylvania, built on
          the safety-first culture our friend Robert Durbin instilled in us.
        </Lead>
        <Button as={Link} to={appConfig.paths.flyIn}>
          Sign up for the Memorial Fly-In
        </Button>
      </Hero>

      <Container>
        <h2>Who we are</h2>
        <p>
          We're a small group of paramotor enthusiasts who fly together,
          mentor new pilots, and run an annual fly-in in memory of our
          founder. If you're a pilot in the region — or thinking about
          becoming one — reach out.
        </p>

        <Cards>
          <Card to={appConfig.paths.flyIn}>
            <h3>Robert Durbin Memorial Fly-In</h3>
            <p>Sign the waiver, get the site briefing, and join us.</p>
          </Card>
          <Card to={appConfig.paths.memorial}>
            <h3>About Robert Durbin</h3>
            <p>Our friend who founded our community and inspired our safety-first culture.</p>
          </Card>
          <Card to={appConfig.paths.contact}>
            <h3>Contact us</h3>
            <p>Questions about flying with us? Send a message.</p>
          </Card>
        </Cards>
      </Container>
    </>
  );
}

export default Welcome;
